import { render, staticRenderFns } from "./UsersLeaderBoard.vue?vue&type=template&id=6a4a2b4d&scoped=true&"
import script from "./UsersLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./UsersLeaderBoard.vue?vue&type=script&lang=js&"
import style0 from "./UsersLeaderBoard.vue?vue&type=style&index=0&id=6a4a2b4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4a2b4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAvatar,VCol,VContainer,VImg,VProgressLinear,VRow,VTab,VTabItem,VTabs})
